/* Sample studio — curated pack adds + build-your-own-five builder (filters, tray,
   load-more). Loaded by BOTH sample-packs and sample-builder sections; the guard
   below stops the second script element from double-binding the delegated
   listeners (which would double every cart add). */
(function () {
  'use strict';
  if (window.__naturaeSampleStudio) return;
  window.__naturaeSampleStudio = true;

  /* Line-item property keys — must match cart-line.liquid's is_set sentinel
     ('Swatch 1') and the data-swatch-N attributes in sample-packs.liquid. */
  var SWATCH_KEY = 'Swatch ';
  var PACK_KEY = 'Pack';

  function addSet(button, properties) {
    if (!window.NaturaeCart || button.hasAttribute('data-loading')) return;
    var variantId = Number(button.getAttribute('data-variant-id'));
    if (!variantId) return;

    button.setAttribute('data-loading', '');
    window.NaturaeCart
      .addItem({ items: [{ id: variantId, quantity: 1, properties: properties }] })
      .then(function () {
        button.removeAttribute('data-loading');
        if (window.NaturaeCartDrawer) window.NaturaeCartDrawer.openAndRefresh();
      })
      .catch(function () {
        button.removeAttribute('data-loading');
        if (window.NaturaeCart.showToast) window.NaturaeCart.showToast('Could not add the set — please try again');
      });
  }

  /* ---------- Curated packs ---------- */
  document.addEventListener('click', function (e) {
    var button = e.target.closest('[data-pack-add]');
    if (!button) return;
    e.preventDefault();
    var properties = {};
    var packName = button.getAttribute('data-pack-name');
    if (packName) properties[PACK_KEY] = packName;
    for (var i = 1; i <= 5; i++) {
      var title = button.getAttribute('data-swatch-' + i);
      if (title) properties[SWATCH_KEY + i] = title;
    }
    addSet(button, properties);
  });

  /* ---------- Swatch zoom tile (tap, not hover — touch/mobile friendly) ---------- */
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-enlarge]');
    if (trigger) {
      var dlg = document.querySelector('[data-swatch-dialog]');
      if (!dlg || !dlg.showModal) return;
      e.preventDefault();
      var g = function (k) { return trigger.getAttribute('data-zt-' + k) || ''; };
      var name = g('name');

      var img = dlg.querySelector('[data-zt-el-img]');
      if (img) { img.src = g('img'); img.alt = name ? name + ' — woven texture detail' : ''; }

      // Set a field's text and hide its host (the element itself, or a row wrapper) when empty.
      var setField = function (sel, val, hostSel) {
        var el = dlg.querySelector(sel);
        if (!el) return;
        el.textContent = val;
        var host = hostSel ? el.closest(hostSel) : el;
        if (host) host.hidden = !val;
      };
      var nameEl = dlg.querySelector('[data-zt-el-name]');
      if (nameEl) nameEl.textContent = name;
      setField('[data-zt-el-fibre]', g('fibre'));
      setField('[data-zt-el-sub]', g('sub'));
      setField('[data-zt-el-width]', g('width'), '[data-zt-row-width]');
      setField('[data-zt-el-length]', g('length'), '[data-zt-row-length]');
      setField('[data-zt-el-coverage]', g('coverage'), '[data-zt-row-coverage]');
      setField('[data-zt-el-price]', g('price'), '[data-zt-row-price]');

      var cta = dlg.querySelector('[data-zt-el-url]');
      if (cta) cta.href = g('url') || '#';

      dlg.showModal();
      return;
    }
    if (e.target.matches('[data-swatch-dialog]')) e.target.close(); // backdrop click
  });

  /* ---------- Builder ---------- */
  function initBuilder(root) {
    if (root.hasAttribute('data-builder-ready')) return;
    root.setAttribute('data-builder-ready', '');

    var grid = root.querySelector('[data-swatch-grid]');
    var meter = root.querySelector('[data-builder-meter]');
    var buyBtn = root.querySelector('[data-builder-add]');
    var emptyMsg = root.querySelector('[data-grid-empty]');
    var loadMore = root.querySelector('[data-load-more]');
    if (!grid) return;

    /* Sets + singles model: every group of 5 = one $15 set product (5 swatch
       properties), remainder = real $5 sample variants. No selection cap. */
    var SET_SIZE = 5;
    var SET_PRICE = buyBtn ? (Number(buyBtn.getAttribute('data-set-price')) || 1500) : 1500;
    var SINGLE_PRICE = buyBtn ? (Number(buyBtn.getAttribute('data-single-price')) || 500) : 500;
    var ADD_LABEL = buyBtn ? (buyBtn.getAttribute('data-add-label') || 'Add to cart') : 'Add to cart';
    var EMPTY_METER = meter ? meter.textContent.trim() : '';
    var state = { c: null, t: null, r: null, m: null };
    var picked = [];
    var drained = false;      // drainAll has been kicked off
    var drainComplete = false; // all pages are in the DOM
    var draining = null;

    function tiles() {
      return Array.prototype.slice.call(grid.querySelectorAll('[data-swatch]'));
    }

    function matches(tile) {
      var ok = true;
      if (state.c) ok = ok && (tile.getAttribute('data-c') || '').split(' ').indexOf(state.c) > -1;
      if (state.t) ok = ok && (tile.getAttribute('data-t') || '') === state.t;
      if (state.r) ok = ok && (tile.getAttribute('data-r') || '').split(' ').indexOf(state.r) > -1;
      if (state.m) ok = ok && (tile.getAttribute('data-m') || '').split(' ').indexOf(state.m) > -1;
      return ok;
    }

    var loadingMsg = root.querySelector('[data-grid-loading]');
    var anyFilterActive = function () {
      return !!(state.c || state.t || state.r || state.m);
    };

    function applyFilters() {
      var anyVisible = false;
      tiles().forEach(function (tile) {
        var ok = matches(tile);
        tile.classList.toggle('is-hidden', !ok);
        if (ok) anyVisible = true;
      });
      // Empty state only when the FULL set is loaded — never mid-drain.
      if (emptyMsg) emptyMsg.hidden = anyVisible || !drainComplete;
    }

    /* Apply a filter only against the COMPLETE grid. If the drain is still
       running, show a loading state and wait — never filter a partial set
       (that caused the wrong-material flash) and never show the empty state
       mid-transition. */
    function runFilter() {
      if (!anyFilterActive()) {
        // clearing: just reveal whatever's loaded (full set arrives via drain)
        if (loadingMsg) loadingMsg.hidden = true;
        applyFilters();
        return;
      }
      if (drainComplete) {
        if (loadingMsg) loadingMsg.hidden = true;
        applyFilters();
        return;
      }
      // not ready: loading state, hide tiles + empty, apply once drained
      if (loadingMsg) loadingMsg.hidden = false;
      if (emptyMsg) emptyMsg.hidden = true;
      grid.classList.add('is-loading');
      drainAll().then(function () {
        if (loadingMsg) loadingMsg.hidden = true;
        grid.classList.remove('is-loading');
        applyFilters();
      });
    }

    function money(cents) {
      var d = cents / 100;
      return '$' + (cents % 100 === 0 ? d.toFixed(0) : d.toFixed(2));
    }

    /* Customer-facing breakdown — always sets + singles, never floor() logic. */
    function describe(n) {
      if (n === 0) return EMPTY_METER;
      var sets = Math.floor(n / SET_SIZE);
      var singles = n - sets * SET_SIZE;
      var total = money(sets * SET_PRICE + singles * SINGLE_PRICE);
      if (sets === 0) {
        var need = SET_SIZE - n;
        return n + (n === 1 ? ' sample · ' : ' samples · ') + total +
          ' — add ' + need + ' more and your five becomes a $15 set (save $5)';
      }
      if (singles === 0) {
        return sets === 1 ? 'Sample set of 5 · $15' : sets + ' sets of 5 · ' + total;
      }
      var setsTxt = (sets === 1 ? '1 set of 5' : sets + ' sets of 5') + ' (' + money(sets * SET_PRICE) + ')';
      var singTxt = singles + (singles === 1 ? ' single (' : ' singles (') + money(singles * SINGLE_PRICE) + ')';
      return setsTxt + ' + ' + singTxt + ' · ' + total +
        ' — add ' + (SET_SIZE - singles) + ' more to complete another set';
    }

    function refreshTray() {
      var n = picked.length;
      if (meter) meter.textContent = describe(n);
      if (buyBtn) {
        buyBtn.disabled = n < 1;
        buyBtn.classList.toggle('is-ready', n >= 1);
        if (n < 1) {
          buyBtn.textContent = ADD_LABEL;
        } else {
          var sets = Math.floor(n / SET_SIZE);
          var singles = n - sets * SET_SIZE;
          buyBtn.textContent = ADD_LABEL + ' — ' + money(sets * SET_PRICE + singles * SINGLE_PRICE);
        }
      }
    }

    /* Build floor(N/5) set lines (each its own 5 swatch properties) + remainder
       $5 single sample variants, added in ONE multi-line cart request. */
    function addBuilder(button) {
      if (!window.NaturaeCart || button.hasAttribute('data-loading')) return;
      var n = picked.length;
      if (n < 1) return;
      var setVariantId = Number(button.getAttribute('data-set-variant-id'));
      if (!setVariantId) return;
      var sets = Math.floor(n / SET_SIZE);
      var items = [];
      for (var s = 0; s < sets; s++) {
        var props = {};
        for (var i = 0; i < SET_SIZE; i++) { props[SWATCH_KEY + (i + 1)] = picked[s * SET_SIZE + i].title; }
        items.push({ id: setVariantId, quantity: 1, properties: props });
      }
      for (var j = sets * SET_SIZE; j < n; j++) {
        if (picked[j].sampleVariantId) items.push({ id: picked[j].sampleVariantId, quantity: 1 });
      }
      if (!items.length) return;
      button.setAttribute('data-loading', '');
      window.NaturaeCart
        .addItem({ items: items })
        .then(function () {
          button.removeAttribute('data-loading');
          picked.length = 0;
          tiles().forEach(function (t) { t.classList.remove('is-selected'); t.setAttribute('aria-pressed', 'false'); });
          refreshTray();
          if (window.NaturaeCartDrawer) window.NaturaeCartDrawer.openAndRefresh();
        })
        .catch(function () {
          button.removeAttribute('data-loading');
          if (window.NaturaeCart.showToast) window.NaturaeCart.showToast('Could not add — please try again');
        });
    }

    function loadNextPage() {
      var nextUrl = grid.getAttribute('data-next-url');
      if (!nextUrl) return Promise.resolve(false);
      var sep = nextUrl.indexOf('?') > -1 ? '&' : '?';
      return fetch(nextUrl + sep + 'section_id=' + grid.getAttribute('data-section-id'), { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-swatch-grid]');
          if (!fresh) { grid.removeAttribute('data-next-url'); return false; }
          Array.prototype.slice.call(fresh.querySelectorAll('[data-swatch]')).forEach(function (tile) {
            grid.appendChild(tile);
          });
          var next = fresh.getAttribute('data-next-url');
          if (next) grid.setAttribute('data-next-url', next);
          else grid.removeAttribute('data-next-url');
          if (loadMore) loadMore.hidden = !next;
          return !!next;
        })
        .catch(function () { return false; });
    }

    /* Filters only see loaded tiles — pull the remaining pages once, the first
       time any filter is switched on, so no colourway hides on page 2+. */
    function drainAll() {
      if (drained) return draining || Promise.resolve();
      drained = true;
      draining = (function next() {
        return loadNextPage().then(function (more) { return more ? next() : null; });
      })().then(function () {
        drainComplete = true;
        // if a filter was chosen while draining, applyFilters runs via runFilter's
        // .then; if not, re-apply so any active state reflects the full set.
        if (!anyFilterActive()) applyFilters();
      });
      return draining;
    }

    root.addEventListener('click', function (e) {
      var filterBtn = e.target.closest('[data-filter]');
      if (filterBtn) {
        var group = filterBtn.getAttribute('data-group');
        var value = filterBtn.getAttribute('data-value');
        var on = state[group] === value;
        state[group] = on ? null : value;
        root.querySelectorAll('[data-filter][data-group="' + group + '"]').forEach(function (b) {
          var active = !on && b === filterBtn;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        runFilter();
        return;
      }

      if (e.target.closest('[data-filter-clear]')) {
        state.c = state.t = state.r = state.m = null;
        root.querySelectorAll('[data-filter]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        runFilter();
        return;
      }

      var more = e.target.closest('[data-load-more]');
      if (more) {
        e.preventDefault();
        loadNextPage().then(applyFilters);
        return;
      }

      var tile = e.target.closest('[data-swatch]');
      if (tile) {
        var id = tile.getAttribute('data-id');
        var existing = picked.findIndex(function (p) { return p.id === id; });
        if (existing > -1) {
          picked.splice(existing, 1);
          tile.classList.remove('is-selected');
          tile.setAttribute('aria-pressed', 'false');
        } else {
          picked.push({
            id: id,
            title: tile.getAttribute('data-title') || '',
            bg: tile.getAttribute('data-bg') || '',
            sampleVariantId: Number(tile.getAttribute('data-sample-variant-id')) || 0
          });
          tile.classList.add('is-selected');
          tile.setAttribute('aria-pressed', 'true');
        }
        refreshTray();
        return;
      }

      var buy = e.target.closest('[data-builder-add]');
      if (buy && !buy.disabled) {
        e.preventDefault();
        addBuilder(buy);
      }
    });

    refreshTray();
    applyFilters();

    /* Start draining the full library on first idle, so by the time a chip is
       clicked the complete set is usually already present (instant filter).
       A click before completion still waits via runFilter's drain guard. */
    var kick = function () { drainAll(); };
    if (root.hasAttribute('data-drain-lazy')) {
      /* Landing pages: never compete with LCP — drain only on first interaction
         with the grid (tap/keyboard), so load-more/filters still see the full set. */
      var lazyKick = function () {
        root.removeEventListener('pointerdown', lazyKick);
        root.removeEventListener('focusin', lazyKick);
        kick();
      };
      root.addEventListener('pointerdown', lazyKick, { passive: true });
      root.addEventListener('focusin', lazyKick);
    } else if ('requestIdleCallback' in window) {
      requestIdleCallback(kick, { timeout: 2000 });
    } else {
      setTimeout(kick, 600);
    }
  }

  function init() {
    document.querySelectorAll('[data-sample-builder]').forEach(initBuilder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var builder = e.target.querySelector('[data-sample-builder]');
    if (builder) initBuilder(builder);
  });
})();
